import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { TenantIpRestrictionModel } from '@/libs/Api';
import { TenantIpRestrictionsDataService } from '@/libs/tenant-ip-restrictions/tenant-ip-restrictions-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const ipRestrictionsStore = registerCrudStore<TenantIpRestrictionModel, TenantIpRestrictionModel>(
    BusinessModule.TenantIpRestriction,
    new TenantIpRestrictionsDataService()
);
